import { Dayjs } from 'dayjs'
import { createSelector } from 'reselect'

import { getOnlyDate } from '~/astra'
import { StoreState, useStore } from '~/store/store'
import { keyOverrideByLocationDay } from '~/utils/locationServiceOverride'
import { getOpeningHours } from '~/utils/openingHours'

import { Location, selectLocationServiceOverrides } from '../'

export const selectGetOpeningHours = createSelector(
    (state: StoreState) => selectLocationServiceOverrides(state, { keyBy: keyOverrideByLocationDay }),
    overridesByLocationDay => {
        const byLocationDay = (location: Location, date: Dayjs) => {
            const locationServiceOverride = overridesByLocationDay.get(
                keyOverrideByLocationDay({ location_uuid: location.uuid, scheduled_date: getOnlyDate(date) })
            )
            return getOpeningHours({ date, location, locationServiceOverride })
        }

        return { byLocationDay }
    }
)

export const useOpeningHours = ({ date, location }: { date: Dayjs; location: Location }) => useStore(selectGetOpeningHours).byLocationDay(location, date)

/** For callers that need to resolve many location-days outside of a component, e.g. a grid's `cellClassName`. */
export const useGetOpeningHours = () => useStore(selectGetOpeningHours).byLocationDay
